module.exports = __webpack_public_path__ + "img/icon2.6fabe357.png";